export default "__VITE_ASSET__a09dca40__"